/*******************************************************************************
 * Copyright (c) 2023 Belltane
 *
 * All rights reserved.
 *
 * Contributors:
 *   
*   Amina Rais - Initial implementation
 * Version: 1.0.0
 *
 *******************************************************************************/

import React from 'react'
import { ToastContainer } from 'react-toastify'
import './App.css'
import Pages from './pages'
import 'react-toastify/dist/ReactToastify.css';
class App extends React.Component {

  render() {


    return (
      <div className="main">
        <ToastContainer />

        <Pages />

      </div>
    )
  }
}

export default App
